import { useGetAsset } from 'ClientPortal/src/api/Queries/assets'
import { useGetValuation } from 'ClientPortal/src/api/Queries/valuations'
import { useTypedParams } from 'ClientPortal/src/router/useTypedParams'

export function useValuationMarketDataPage() {
    const { assetId, valuationId } = useTypedParams(['valuationId', 'assetId'])
    const { asset, isAssetPending } = useGetAsset({ assetId })
    const { valuation, isValuationPending } = useGetValuation({ valuationId })

    return {
        asset,
        valuation,
        isComparablesPending: isAssetPending || isValuationPending,
    }
}
